import { Draft, DraftConfiguration } from '@/types';
import { getViewFromConfiguration } from '@/model/configuration/getViewFromConfiguration';
import { getProductType } from '@/model/draft/getProductType';
import { getOtherSleeveView } from '@/model/productType/getOtherSleeveView';
import { getConfigurations } from './getConfigurations';
import { getConfigurationsOnView } from './getConfigurationsOnView';

export const getConfigurationsForPrintTypeAlignment = (
  draft: Draft,
  configuration: DraftConfiguration
) => {
  const productType = getProductType(draft);
  const configurations = getConfigurations(draft);
  const view = getViewFromConfiguration(productType, configuration);
  const otherConfigurations = getConfigurationsOnView(configurations, view).filter(
    (otherConfiguration) => otherConfiguration.cid !== configuration.cid
  );
  let includesOtherSleeve = false;

  // align print types across sleeves too
  const otherSleeveView = getOtherSleeveView(productType, view);
  if (otherSleeveView) {
    const configurationsOnOtherSleeve = getConfigurationsOnView(configurations, otherSleeveView);
    if (configurationsOnOtherSleeve.length > 0) {
      otherConfigurations.push(...configurationsOnOtherSleeve);
      includesOtherSleeve = true;
    }
  }

  return [otherConfigurations, includesOtherSleeve] as const;
};
